import React, { useState, useEffect } from "react";
import { Form, Container, Row } from 'react-bootstrap';
import CardGroupMediaComponent from "../widgets/CardGroupMedia/CardGroupMediaComponent.jsx";

const PackageBoardComponent = ({ packages, readOne: readOneSlug, sortTypePreferenceTuple }) => {
    const [packageBoardSortType, setPackageBoardSortType] = sortTypePreferenceTuple ? sortTypePreferenceTuple : [null, null];

    const sortType = [
        { value: 'date', label: "Date création (plus récente d'abord)", method: (a, b) => new Date(b.createdAt) - new Date(a.createdAt) },
        { value: 'name', label: 'Ordre alphabetique', method: (a, b) => a.name.localeCompare(b.name) },
        { value: 'apkCount', label: "Nombre version", method: (a, b) => b.apkCount - a.apkCount }
    ];

    const [sort, setSort] = useState(packageBoardSortType ? sortType.find(type => type.value === packageBoardSortType) : sortType[0]);

    const [sortedPackages, setSortedPackages] = useState([]);

    useEffect(() => {
        setSortedPackages([...packages.sort(sort.method)]);
    }, [sort, packages]);

    const sortChoice = (e) => {
        const sortSelected = sortType.filter(type => type.value === e.target.value)[0];
        setSort(sortSelected);
        // eslint-disable-next-line no-unused-expressions
        setPackageBoardSortType ? setPackageBoardSortType(sortSelected.value) : null;
    };

    const checkSort = sortType.map(
        type => <Form.Check inline name="sort" label={type.label} type='radio' value={type.value} key={type.value} id={type.value} onChange={sortChoice} checked={sort.value == type.value} />
    );

    return (
        <Container fluid>
            <Row className="mb-4"><div className="d-flex justify-content-around check-sort">{checkSort}</div></Row>
            <Row>
                <CardGroupMediaComponent mediaType='package' mediaList={sortedPackages} readOne={readOneSlug} />
            </Row>
        </Container>
    );

}

export default PackageBoardComponent;